'use strict';module.exports=require('fs');